import { tenantSubdomain } from '../tenant/tenantSubdomain';

let inMemoryTenant: any = null;

export default class AuthCurrentTenant {
  static selectAndSaveOnStorageFor(currentUser) {
    if (!currentUser) {
      return null;
    }

    if (!currentUser.tenants) {
      return null;
    }

    const activeTenants = currentUser.tenants.filter(
      (tenantUser) => tenantUser.status === 'active',
    );

    if (!activeTenants || !activeTenants.length) {
      return null;
    }

    const tenantId = this.get();

    let tenant;

    // When subdomain mode is active, prioritize the tenant matching
    // the current subdomain to avoid cross-tenant redirects
    if (tenantSubdomain.isEnabled && tenantSubdomain.isSubdomain) {
      tenant = activeTenants
        .map((tenantUser) => tenantUser.tenant)
        .find((t) => tenantSubdomain.isSubdomainOf(t.url));
    }

    if (!tenant && tenantId) {
      tenant = activeTenants
        .map((tenantUser) => tenantUser.tenant)
        .find((tenant) => tenant.id === tenantId);
    }

    tenant = tenant || activeTenants[0].tenant;

    if (
      tenant &&
      tenantSubdomain.isEnabled &&
      !tenantSubdomain.isSubdomainOf(tenant.url)
    ) {
      return tenantSubdomain.redirectAuthenticatedTo(
        tenant.url,
      );
    }

    this.set(tenant);
    return tenant;
  }

  static get() {
    try {
      const tenantASString = localStorage.getItem('tenant') || null;
      if (tenantASString) {
        return JSON.parse(tenantASString).id;
      }
    } catch {
      // storage blocked by browser, tenant will be resolved from subdomain
    }
    return inMemoryTenant?.id || null;
  }

  static getSettings() {
    try {
      const tenantASString = localStorage.getItem('tenant') || null;
      if (tenantASString) {
        const tenant = JSON.parse(tenantASString);
        if (tenant) {
          if (Array.isArray(tenant.settings)) {
            if (tenant.settings.length) {
              return tenant.settings[0];
            }
          } else {
            return tenant.settings;
          }
        }
      }
    } catch {
      // storage blocked by browser, settings will be fetched from backend
    }
    if (inMemoryTenant?.settings) {
      return Array.isArray(inMemoryTenant.settings)
        ? inMemoryTenant.settings[0] || null
        : inMemoryTenant.settings;
    }
    return null;
  }

  static set(tenant) {
    if (!tenant) {
      return this.clear();
    }
    inMemoryTenant = tenant;
    try {
      localStorage.setItem('tenant', JSON.stringify(tenant));
    } catch {
      // storage blocked by browser, tenant context lives in memory only
    }
  }

  static clear() {
    inMemoryTenant = null;
    try {
      localStorage.removeItem('tenant');
    } catch {
      // storage blocked by browser
    }
  }
}
